import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_75: FaireProductEntity = {
  token: "catalog_prod_prod-75",
  type: "product",
  name: "Decorative Item A",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 97.43,
  msrpDollars: 243.58,
  sku: "AN0075",
  caseSize: 6,
  material: "Metal",
  collectionToken: "col_andean-touch",
  isNew: true,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 82,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_stationery-writing"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
